import React, { useState } from 'react';
import { Card, Statistic } from 'antd';
import { round10, calculateDiff } from 'shared/utils/numbers/round';
import { ComparisonValue } from 'components/common/comparison-value';
import type { IProfitAggregatedStatisticProps } from './types';

export const ProfitAggregatedStatistic: React.FC<IProfitAggregatedStatisticProps> = (props) => {
  const { value, comparisonValue, isPersonal = false } = props;

  const [isHiddenBonus, setIsHiddenBonus] = useState(isPersonal);
  const toggleHiddenBonus = () => {
    setIsHiddenBonus(!isHiddenBonus);
  };

  const totalProfitDiff = calculateDiff(value.totalProfit, comparisonValue?.totalProfit);
  const totalProfitByMapDiff = calculateDiff(value.totalProfitByMap, comparisonValue?.totalProfitByMap);

  const totalBonusDiff = calculateDiff(value.totalBonus, comparisonValue?.totalBonus);
  const totalBonusByMapDiff = calculateDiff(value.totalBonusByMap, comparisonValue?.totalBonusByMap);

  return (
    <>
      <Card>
        <Statistic
          title={isPersonal ? 'Your profit' : 'Profit by mileage'}
          value={value.totalProfit}
          suffix='€'
          precision={1}
        />
        {comparisonValue && totalProfitDiff !== 0 && (
          <ComparisonValue value={round10(comparisonValue.totalProfit)} diff={totalProfitDiff} suffix='€' />
        )}
      </Card>
      {!isPersonal && (
        <Card>
          <Statistic title={'Profit by map'} value={value.totalProfitByMap} suffix='€' precision={1} />
          {comparisonValue && totalProfitByMapDiff !== 0 && (
            <ComparisonValue value={round10(comparisonValue.totalProfitByMap)} diff={totalProfitByMapDiff} suffix='€' />
          )}
        </Card>
      )}

      <Card>
        <Statistic title='Unfinished orders' value={value.notFinishedCargos} suffix='' precision={0} />
        {comparisonValue && '-'}
      </Card>
      <Card onClick={toggleHiddenBonus}>
        <Statistic
          title={isPersonal ? 'Your monthly bonus' : 'Monthly bonus by mileage'}
          value={isHiddenBonus ? '****' : value.totalBonus}
          suffix={isHiddenBonus ? '' : '€'}
          precision={1}
        />
        {comparisonValue && !isHiddenBonus && totalBonusDiff !== 0 ? (
          <ComparisonValue value={round10(comparisonValue.totalBonus)} diff={totalBonusDiff} suffix='€' />
        ) : null}
      </Card>
      {!isPersonal ? (
        <Card>
          <Statistic
            title={'Monthly bonus by map'}
            value={isHiddenBonus ? '****' : value.totalBonusByMap}
            suffix={isHiddenBonus ? '' : '€'}
            precision={1}
          />
          {comparisonValue && !isHiddenBonus && totalBonusByMapDiff !== 0 ? (
            <ComparisonValue value={round10(comparisonValue.totalBonusByMap)} diff={totalBonusByMapDiff} suffix='€' />
          ) : null}
        </Card>
      ) : null}
    </>
  );
};
